export default "__VITE_ASSET__3MY4TMMN__";